export type ShedulerTaskType = "gold" | "loading" | "sweepbuck" | "jackpotTicket" | string;

export interface SchedulerState {
    tasks: {[key: string]:  (() => Promise<void>)[]},
    tasksRunning: {[key: string]: boolean};
}

export const SCHEDULER_INIT_STATE: SchedulerState = {
    tasks: {},
    tasksRunning: {}
}